import { Phone, Clock, ShieldCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business";

const POINTS = [
  "No hidden costs — what we quote is what you pay.",
  "Free no-obligation quotes for larger jobs.",
  "All work certified, signed off and guaranteed.",
];

export const Pricing = () => (
  <section
    id="pricing"
    data-testid="pricing-section"
    className="relative bg-[#0A0A0A] py-28 lg:py-36 overflow-hidden"
  >
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-[#1E90FF]/[0.04] blur-[140px] rounded-full pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-12 bg-[#1E90FF]/40" />
          <span className="text-[11px] font-bold uppercase tracking-[0.3em] text-[#1E90FF]">
            Transparent Pricing
          </span>
          <span className="h-px w-12 bg-[#1E90FF]/40" />
        </div>
        <h2
          className="text-4xl sm:text-5xl lg:text-6xl text-white font-semibold leading-[1.05] tracking-tight"
          style={{ fontFamily: "Outfit" }}
        >
          No surprises.
          <br />
          <span className="text-[#A0AAB2] italic font-light">Just honest rates.</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 max-w-4xl mx-auto">
        {/* Callout */}
        <div data-testid="price-callout" className="bg-[#0F0F0F] p-10 lg:p-12 relative">
          <div className="absolute top-6 right-6 text-[10px] tracking-[0.25em] text-[#A0AAB2]/60 uppercase">
            / 01
          </div>
          <div className="w-12 h-12 border border-[#1E90FF]/30 flex items-center justify-center mb-8 bg-[#1E90FF]/5">
            <Phone className="w-5 h-5 text-[#1E90FF]" strokeWidth={1.5} />
          </div>
          <div className="text-[10px] tracking-[0.3em] text-[#1E90FF] uppercase mb-2">
            Callout
          </div>
          <h3 className="text-3xl text-white font-medium mb-2" style={{ fontFamily: "Outfit" }}>
            Includes the first hour
          </h3>
          <div className="flex items-baseline gap-2 mt-6 mb-4">
            <span className="text-6xl text-white font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
              £90
            </span>
            <span className="text-[#A0AAB2] text-sm">/ callout + 1st hour</span>
          </div>
          <p className="text-[#A0AAB2] text-sm leading-relaxed">
            Covers travelling to your property and your first hour of on-site work.
            Most small jobs are completed within this time.
          </p>
        </div>

        {/* Hourly */}
        <div data-testid="price-hourly" className="bg-[#0F0F0F] p-10 lg:p-12 relative">
          <div className="absolute top-6 right-6 text-[10px] tracking-[0.25em] text-[#A0AAB2]/60 uppercase">
            / 02
          </div>
          <div className="w-12 h-12 border border-[#1E90FF]/30 flex items-center justify-center mb-8 bg-[#1E90FF]/5">
            <Clock className="w-5 h-5 text-[#1E90FF]" strokeWidth={1.5} />
          </div>
          <div className="text-[10px] tracking-[0.3em] text-[#1E90FF] uppercase mb-2">
            Continued work
          </div>
          <h3 className="text-3xl text-white font-medium mb-2" style={{ fontFamily: "Outfit" }}>
            Every additional hour
          </h3>
          <div className="flex items-baseline gap-2 mt-6 mb-4">
            <span className="text-6xl text-white font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>
              £70
            </span>
            <span className="text-[#A0AAB2] text-sm">/ hour thereafter</span>
          </div>
          <p className="text-[#A0AAB2] text-sm leading-relaxed">
            Charged per hour after the first. Larger jobs can be quoted as a
            fixed price up-front — just ask.
          </p>
        </div>
      </div>

      <div className="mt-12 max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6 text-center sm:text-left">
        {POINTS.map((p) => (
          <div key={p} className="flex items-start gap-3 justify-center sm:justify-start">
            <ShieldCheck className="w-4 h-4 text-[#1E90FF] mt-1 shrink-0" strokeWidth={1.5} />
            <span className="text-sm text-[#A0AAB2] leading-relaxed">{p}</span>
          </div>
        ))}
      </div>

      <div className="mt-12 text-center">
        <a
          href={`tel:${BUSINESS.phoneRaw}`}
          data-testid="pricing-call-button"
          className="inline-flex items-center gap-3 px-8 py-4 bg-[#1E90FF] hover:bg-[#0073E6] text-white font-medium tracking-wide transition-all duration-300"
        >
          <Phone className="w-4 h-4" />
          <span>Call {BUSINESS.phone} for a quick quote</span>
        </a>
      </div>
    </div>
  </section>
);
